<template>
  <!-- Hero Section -->
  <section id="hero" class="main hero section">
    <div id="hero-carousel" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="5000">
      <div class="carousel-item active">
        <img src="../assets/img/slider/asnbkpp.jpg" alt="" />
        <div class="container">
          <h3>
            Selamat Datang di Portal<br />
            <strong>Badan Kepegawaian dan Pengembangan Sumber Daya Manusia</strong><br />Kabupaten Kendal
          </h3>
        </div>
      </div>
      <!-- End Carousel Item -->
    </div>
  </section>
  <!-- /Hero Section -->
</template>

<script>
export default {
  name: 'HeroSection',
};
</script>

<style></style>
